document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("announcement-popup");

    if (!popup) return;

    // 홈페이지에서만 표시
    if (
        popup.dataset.homeOnly === "true" &&
        window.location.pathname !== "/"
    ) {
        return;
    }

    // 오늘 하루 보지 않기
    const hideUntil = localStorage.getItem("announcement_popup_hide");

    if (hideUntil && Date.now() < Number(hideUntil)) {
        return;
    }

    // Delay
    const delay = Number(popup.dataset.delay || 2);

    setTimeout(() => {
        popup.style.display = "flex";
    }, delay * 1000);

    function closePopup() {

        const checkbox = document.getElementById("ap-hide-day");

        if (checkbox && checkbox.checked) {

            const tomorrow = Date.now() + (24 * 60 * 60 * 1000);

            localStorage.setItem(
                "announcement_popup_hide",
                tomorrow
            );

        }

        popup.style.display = "none";
    }

    popup.querySelector(".ap-close").addEventListener("click", closePopup);

    popup.addEventListener("click", function (e) {

        if (e.target === popup) {

            closePopup();

        }

    });

    document.addEventListener("keydown", function (e) {

        if (e.key === "Escape") {

            closePopup();

        }

    });

});